import React, { createContext, ReactNode, useContext, useState } from 'react';

export type BetsContextAttributes = {
  selectedTicketId: string;
};

export type BetsContextProps = {
  context: BetsContextAttributes | undefined;
  setContext: (context: BetsContextAttributes) => void;
  clearContext: () => void;
};

const BetsContext = createContext<BetsContextProps>({
  context: undefined,
  setContext: () => {},
  clearContext: () => {}
});

export function BetsContextProvider({ children }: { children: ReactNode }) {
  const [currentContext, setCurrentContext] = useState<BetsContextAttributes | undefined>();

  return (
    <BetsContext.Provider value={{ context: currentContext, setContext, clearContext }}>
      {children}
    </BetsContext.Provider>
  );

  function setContext(newContext: BetsContextAttributes) {
    setCurrentContext({ ...newContext });
  }
  function clearContext() {
    setCurrentContext(undefined);
  }
}

export default function useBetsContext(): BetsContextProps {
  const context = useContext(BetsContext);
  return { ...context };
}
